import { render, staticRenderFns } from "./CustomButtonActionDetails.vue?vue&type=template&id=20856582&scoped=true&"
import script from "./CustomButtonActionDetails.vue?vue&type=script&lang=js&"
export * from "./CustomButtonActionDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomButtonActionDetails.vue?vue&type=style&index=0&id=20856582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20856582",
  null
  
)

export default component.exports